import { getAuthHeaders } from './auth';

class ApiError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
  }
}

let logoutCallback: (() => void) | null = null;

export const setLogoutCallback = (callback: () => void) => {
  logoutCallback = callback;
};

const handleApiError = async (response: Response) => {
  const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
  const errorMessage = errorData.error || 'Request failed';

  // Check for "Invalid token" error
  if (response.status === 401 && errorMessage === 'Invalid token') {
    console.log('Invalid token detected, triggering logout...');
    if (logoutCallback) {
      logoutCallback();
    }
    throw new ApiError('Session expired. Please log in again.', response.status);
  }

  throw new ApiError(errorMessage, response.status);
};

export const apiRequest = async (
  url: string,
  options: RequestInit = {}
): Promise<any> => {
  const headers = {
    ...getAuthHeaders(),
    ...options.headers,
  };

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (!response.ok) {
    await handleApiError(response);
  }

  return response.json();
};

export const apiRequestRaw = async (
  url: string,
  options: RequestInit = {}
): Promise<Response> => {
  const headers = {
    ...getAuthHeaders(),
    ...options.headers,
  };

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (!response.ok) {
    await handleApiError(response);
  }

  return response;
};

export const apiRequestFormData = async (
  url: string,
  options: RequestInit = {}
): Promise<any> => {
  // Don't set Content-Type for FormData - let browser set it with boundary
  const headers = {
    ...getAuthHeaders(),
    ...options.headers,
  };

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (!response.ok) {
    await handleApiError(response);
  }

  return response.json();
};